import React, { useEffect } from 'react';
import { Link } from 'gatsby';
import { ReactComponent as Close } from "@svgs/close.svg";
import { ReactComponent as ArrowDown } from "@svgs/arrow-down.svg";
import { navigate } from 'gatsby';
import { checkIfEmpty } from '../helpers';
import { onEnterKeyPress } from '@src/utils/general';
import useToggleStates from '@src/hooks/useToggleStates';

const ProductFilter = ({ group, query, index }) => {
  const { toggleAllFunction } = useToggleStates()

  const filterClassname = 'w-full relative flex justify-between select-none cursor-pointer';

	const hasSubcategories = group?.subcategories?.length > 0;
	const hasSelectedSubcategories = hasSubcategories && group?.subcategories?.find(subcategory => subcategory?.active) || group?.active;

  const toPath = (_group) => {
		return `/collections/${checkIfEmpty(_group?.slug?.current)}`;
	}

	const onLinkClick = () => {
		toggleAllFunction("sidebar", false);
	}

	if (query) return (
		<div className='flex flex-col group border-t-1 last:border-b-1 max-md:first:border-t-0 border-gray' role='link' tabIndex={0}>
			<div className={`${filterClassname} bg-light-gray text-safety-green transition-all duration-300`}>
				<div 
					className={`py-5 w-full px-0`}
				>
					<p className={`pl-4 pr-3 border-l-4 border-safety-green heading`}>
						<span className='text-soft-black font-medium'>
							Search: 
						</span>
						{' '}
						{query}
					</p>
				</div>
				<Close className={'w-8 cursor-pointer p-2 flex-shrink-0'} onClick={() => { onLinkClick(); navigate('/collections/')}} onKeyDown={(e) => onEnterKeyPress(e, () => { onLinkClick(); navigate('/collections/')})} aria-label={'Go Back to Collection Button'} tabIndex={0} />
			</div>
		</div>
	)

  return (
		<div className='flex flex-col group border-t-1 last:border-b-1 max-md:first:border-t-0 border-gray first:collection-item'>
			{hasSubcategories ? (
				<>
					<div className='sr-only' role={'list'} tabIndex={0} aria-label={group?.title}>
						<div role={'listitem'}>
							<Link to={toPath(group)} onClick={onLinkClick}>
									All
							</Link>
							<Close className={`${group?.active ? "block" : "hidden"}`} onKeyDown={(e) => onEnterKeyPress(e, () => { onLinkClick(); navigate('/collections/') })} aria-label={'Close selected collection button'} tabIndex={group?.active ? 0 : -1} />
						</div>
						{group?.subcategories?.filter(subcategory => subcategory?.products?.length > 0).map((subcategory, index) => (
							<div key={`subcategory-${index}`} role={'listitem'}>
								<Link to={toPath(subcategory)} onClick={onLinkClick}>
									{subcategory?.title}
								</Link>
								<Close className={`${subcategory?.active ? "block" : "hidden"}`} onKeyDown={(e) => onEnterKeyPress(e, () => {onLinkClick();navigate('/collections/')})} aria-label={'Close selected collection button'} tabIndex={subcategory?.active ? 0 : -1} />
							</div>
						))}
					</div>

					<div className={`${filterClassname} ${hasSelectedSubcategories ? 'text-safety-green' : 'hover:text-safety-green'} transition-all duration-300`} >
						<div className={`py-5 w-full px-5 md:px-0`}>
							<p className='heading'>
								{group?.title}
							</p>
						</div>
						<ArrowDown className={'absolute right-5 md:right-2 top-1/2 -translate-y-1/2 fill-black'} />
					</div>

					<div className={`flex gap-y-2.5 flex-col transition-all duration-300 ${hasSelectedSubcategories ? 'pb-5' : 'max-h-0 invisible opacity-0 group-hover:max-h-96 group-hover:visible group-hover:opacity-100 group-hover:pb-5'}`}>
						
						<div key={`${group?.title}-all`} className='flex'>
							<Link 
								to={toPath(group)}
								onClick={onLinkClick}
								className={`w-full flex items-center transition-all px-5 md:px-0 ${group?.active ? 'text-safety-green' : ' text-soft-black hover:text-safety-green md:hover:pl-2.5'}`}
							>
								<p className={`${group?.active ? 'pl-4 pr-3 border-l-4 border-safety-green' : 'p-0'}`}>
									All
								</p>
							</Link>

							<Close className={`w-7 cursor-pointer p-2 max-md:mr-3 ${group?.active ? 'block' : 'hidden'}`} onClick={() => { onLinkClick(); navigate('/collections/')}} onKeyDown={(e) => onEnterKeyPress(e, () => { onLinkClick(); navigate('/collections/')})} aria-label={'Close selected collection button'} role='button' tabIndex={group?.active ? 0 : -1} />
						</div>

						{group?.subcategories?.filter(subcategory => subcategory?.products?.length > 0).map((subcategory, _index) => (
							<div key={`subcategory-${_index}`} className='flex'>
								<Link 
									to={toPath(subcategory)}
									onClick={onLinkClick}
									className={`w-full flex items-center transition-all px-5 md:px-0 ${subcategory?.active ? 'text-safety-green' : ' text-soft-black hover:text-safety-green md:hover:pl-2.5'}`}
									tabIndex={-1}
								>
									<p className={`${subcategory?.active ? 'pl-4 pr-3 border-l-4 border-safety-green' : 'p-0'}`}>
										{subcategory?.title}
									</p>
								</Link>

								<Close className={`w-7 cursor-pointer p-2 max-md:mr-3 ${subcategory?.active ? 'block' : 'hidden'}`} onClick={() => {onLinkClick(); navigate('/collections/')}} onKeyDown={(e) => onEnterKeyPress(e, () => {onLinkClick(); navigate('/collections/')})} aria-label={'Close selected collection button'} role="button" tabIndex={subcategory?.active ? 0 : -1} />
							</div>
						))}

					</div>
				</>
			) : (
				<div className={`${filterClassname} ${(group?.active || hasSelectedSubcategories) ? 'bg-light-gray text-safety-green' : 'hover:pl-2.5 hover:text-safety-green'} transition-all duration-300`}>
					<Link 
						to={toPath(group)}
						onClick={onLinkClick}
						className={`py-5 w-full ${group?.active ? 'px-0 ' : 'px-5 md:px-0'}`}
					>
						<p className={`${group?.active ? 'pl-4 pr-3 border-l-4 border-safety-green' : 'p-0'} heading`}>
							{group?.title}
						</p>
					</Link>

					<Close className={`w-8 cursor-pointer p-2 flex-shrink-0 ${group?.active ? 'block' : 'hidden'}`} onClick={() => { onLinkClick(); navigate('/collections/')}} onKeyDown={(e) => onEnterKeyPress(e, () => { onLinkClick(); navigate('/collections/')})} aria-label={'Go Back to Collection Button'} role="button" tabIndex={group?.active ? 0 : -1} />
				</div>
			)}
		</div>
  );
}

export default ProductFilter;